<span class="p-2" placement="top" ngbTooltip="This field is optional.">
  <small class="mx-2 text-info">(Optional)</small>
</span>
